import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'


const CustomPhoneInput = (props) => {

    return (
        <PhoneInput
            inputStyle={
                { height: 'var(--form-input-height)',
                    fontSize: 'var(--form-input-font-size)',
                    borderRadius: 'var(--form-input-border-radius)' }}
            buttonStyle={
            {
                left: '2px',
                borderColor: 'transparent',
                borderRight: 'none',
                background: 'transparent',
                height: 'calc(var(--form-input-height) - 2px)',
                fontSize: 'var(--form-input-font-size)',
                borderTopLeftRadius: 'var(--form-input-border-radius)',
                borderBottomLeftRadius: 'var(--form-input-border-radius)' }}
            {...props}

        />
    );
};

export default CustomPhoneInput;
